import { Layers } from 'lucide-react'

export interface CoreThemeItem {
  theme: string
  insight: string
}

export function CoreThemesList({
  themes,
  limit = 2,
  showHeader = true,
}: {
  themes: CoreThemeItem[] | undefined
  limit?: number
  showHeader?: boolean
}) {
  if (!themes || themes.length === 0) return null

  return (
    <div className="space-y-4">
      {showHeader && (
        <div className="flex items-center gap-2">
          <Layers className="h-5 w-5 text-emerald-600 dark:text-emerald-400" />
          <h4 className="font-semibold text-foreground">Core Themes</h4>
        </div>
      )}

      <div className="space-y-3">
        {themes.slice(0, limit).map((theme, index) => (
          <div key={`${theme.theme}-${index}`} className="p-4 rounded-lg bg-muted/50 border">
            <div className="flex items-start gap-3">
              <div className="w-2 h-2 rounded-full bg-emerald-500 dark:bg-emerald-400 mt-2 flex-shrink-0" />
              <div>
                <p className="font-medium text-foreground text-sm">{theme.theme}</p>
                <p className="text-xs text-muted-foreground mt-1 leading-relaxed">{theme.insight}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default CoreThemesList


